import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  min-height: 100%;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  display: block;
  margin-top: ${theme.spacing(2)};

  font-weight: 700;
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(4, 0, 3)};
`
